import React from "react"
class Flash extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            messages: [],
            removal_ids: []
        };

        //this.add_message = this.add_message.bind(this);
        this.remove_message = this.remove_message.bind(this);

        this.FLASH_TYPE_TO_ICON = {
            'success':'check',
            'warning':'triangle-exclamation',
            'danger':'xmark',
            'info':'info'
        };

    }

    componentDidUpdate(prev_props) {
        if ([null,undefined].includes(this.props.messages)){
            if ([null,undefined].includes(this.state.messages) || this.state.messages.length > 0){
                return this.setState({
                    messages: []
                });
            }
        }
        if (![null,undefined].includes(this.props.messages) && prev_props.timestamp === this.props.timestamp){//prev_props.messages.map((m) => m.id).sort().join('') === this.props.messages.map((m) => m.id).sort().join('')){
            return null;
        }
        let i, id;
        let messages = this.state.messages;
        const ids = messages.map((m) => m.id);
        for (i = 0 ; i < this.props.messages.length ; i++){
            id = this.props.messages[i].id;
            if (!this.state.removal_ids.includes(id)){//(!ids.includes(this.props.messages[i].id)){
                if (![null,undefined].includes(this.props.messages[i].disappear_after)){
                    setTimeout(() => {
                        let rids = this.state.removal_ids;
                        rids.push(id);
                        this.setState({
                            removal_ids: rids
                        });
                        this.remove_message(id);
                    }, this.props.messages[i].disappear_after * 1000);
                }
            }
        }
        this.setState({
            messages: this.props.messages//messages
        });
    }

    remove_message(id){
        let messages = this.state.messages.filter((m) => m.id != id);
        this.setState({
            messages: messages
        });
        this.props.on_update({flash_messages: messages});
    }

    static add_message(ctx, msg, type, disappear_after=null){
        let msgs;
        if ([null,undefined].includes(ctx.state.flash_messages)){
            msgs = [];
        } else {
            msgs = ctx.state.flash_messages;
        }
        msgs.push({
            id: (Math.random() + 1).toString(36).substring(2),
            content: msg,
            type: type,
            disappear_after: disappear_after
        });
        ctx.setState({
            flash_messages: msgs,
            flash_timestamp: String(Date.now())
        });
    }

    render(){
        return (this.state.messages.map(
            (message, index) => 
            <div className={`psintegril-flash psintegril-flash-${message.type}`} key={index}>
                <div className="psintegril-flash-content">
                    <div className="psintegril-flash-message">
                        {message.content}
                    </div>
                </div>
            </div>
        ));
    }
}

export default Flash;
